import { Box, Button, Divider, Stack, Typography } from '@mui/material';
import React from 'react';

import { useNavigate } from 'react-router-dom';
import { PatientSummary } from '../../../store/patientsSlice';
import { PatientStatusChip } from '../../ui/DaliaComponents';

interface PatientSidebarProps {
  patient: PatientSummary;
}

const PatientSidebar: React.FC<PatientSidebarProps> = ({ patient }) => {
  const navigate = useNavigate();
  const handleNavigateToPatient = () => {
    navigate(`/patient/${patient.id}/view/inclusion`);
  };

  return (
    <Stack direction="column" gap={2} sx={{ p: 2 }}>
      <Typography fontWeight="bold" sx={{ color: 'text.secondary' }} variant="h5">
        Mayssan Hakiki
      </Typography>
      <PatientStatusChip patient={patient} />

      <Divider />

      {/* Patient Info */}
      <Typography fontWeight="bold" sx={{ color: 'text.secondary' }} variant="h6">
        Informations patients
      </Typography>

      <Box
        sx={{
          borderRadius: 2,
          boxShadow: 0,
          p: 2,
          backgroundColor: 'primary.light',
          mb: 2,
        }}
      >
        <Typography sx={{ color: 'text.secondary', fontWeight: 'bold' }}>Sexe</Typography>
        <Typography sx={{ color: 'primary.main', fontWeight: 'bold', mb: 2 }}>Femme </Typography>

        <Typography sx={{ color: 'text.secondary', fontWeight: 'bold' }}>Pathologie</Typography>
        <Typography sx={{ color: 'primary.main', fontWeight: 'bold', mb: 2 }}>Dépression résistante </Typography>

        <Typography sx={{ color: 'text.secondary', fontWeight: 'bold' }}>Traitement</Typography>
        <Typography sx={{ color: 'primary.main', fontWeight: 'bold', mb: 2 }}>Fluoxétine 20mg </Typography>

        <Typography sx={{ color: 'text.secondary', fontWeight: 'bold' }}>Dernière consultation</Typography>
        <Typography sx={{ color: 'primary.main', fontWeight: 'bold', mb: 2 }}>20/11/2024 </Typography>
      </Box>

      {/* Patient Action Button */}
      <Button color="primary" onClick={handleNavigateToPatient} variant="contained">
        Accéder à la fiche patient
      </Button>

      <Divider />

      {/* Help Section */}
      <Box>
        <Typography fontWeight="bold" sx={{ color: 'text.secondary', mb: 2 }} variant="h6">
          Besoin d’aide ?
        </Typography>
        <Typography fontWeight="bold" sx={{ color: 'text.secondary', mb: 2, fontSize: '1rem' }} variant="h6">
          Centre d’aide Dalia
        </Typography>
        <Typography fontWeight="bold" sx={{ color: 'text.secondary', mb: 2, fontSize: '1rem' }} variant="h6">
          Orientation
        </Typography>
      </Box>
    </Stack>
  );
};

export default PatientSidebar;
